import localforage from 'localforage';
import { useEffect } from 'react';
import { GLOBAL_WINDOW_STORE_KEY } from '../../../../app/const';
import { useUserPageContextState } from '../../../../user';
import { IS_LIST_PAGE_KEY, STORAGE_PARTIAL_KEY } from '../const';
import { getAsyncStorage } from '../storage';

export function useListProviderSyncStateInitialization() {
	const { id: userId } = useUserPageContextState();

	useEffect(() => {
		async function init() {
			const keys = await localforage.keys();

			const listKeys = keys.filter(
				(key) =>
					key.indexOf(STORAGE_PARTIAL_KEY) !== -1 &&
					key.indexOf(IS_LIST_PAGE_KEY) !== -1 &&
					key.indexOf(`uId:${userId}`) !== -1,
			);

			for await (const requestKey of listKeys) {
				const asyncStoreValue = await getAsyncStorage(requestKey);

				window[GLOBAL_WINDOW_STORE_KEY][requestKey] = asyncStoreValue;
			}
		}

		if (typeof userId === 'undefined') {
			return;
		}

		init();
	}, [userId]);
}
